import { Injectable, signal } from '@angular/core';
import { BossAuthAccessTokens } from '../../auth/schemas/boss-auth.schema';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BossAuthTokenService {
  authAccessTokens = signal<BossAuthAccessTokens | null>(null);

  cookieName = 'boss_auth_session';

  constructor() {}

  /**
   * Retrieves stored tokens from cookies.
   */
  get(): BossAuthAccessTokens | null {
    const data = this.getCookie(this.cookieName);
    // console.trace('getting tokens', data);
    return data ? (JSON.parse(data) as BossAuthAccessTokens) : null;
  }

  /**
   * Stores tokens securely in cookies.
   */
  set(data: BossAuthAccessTokens) {
    const now = Date.now();
    data.expires_at = now + data.expires;
    this.authAccessTokens.set(data);
    this.setCookie(this.cookieName, JSON.stringify(data), {
      secure: environment.production ? true : false,
      sameSite: 'Strict',
      path: '/',
      maxAge: Math.round(data.expires / 1000), // Convert to seconds
    });
  }

  /**
   * Clears the authentication session by removing tokens from cookies.
   */
  destroy() {
    this.authAccessTokens.set(null);
    this.deleteCookie(this.cookieName);
  }

  /**
   * Helper function to set a cookie with options.
   */
  private setCookie(name: string, value: string, options: Record<string, any>) {
    const optString = Object.entries(options)
      .map(([key, val]) => `${key}=${val}`)
      .join('; ');
    document.cookie = `${name}=${encodeURIComponent(value)}; ${optString}`;
  }

  /**
   * Helper function to retrieve a cookie value.
   */
  private getCookie(name: string): string | null {
    const matches = document.cookie.match(
      new RegExp(
        `(?:^|; )${name.replace(/([.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
      ),
    );
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  /**
   * Helper function to delete a cookie.
   */
  private deleteCookie(name: string) {
    // console.trace('Deleting cookie', name);
    document.cookie = `${name}=; Max-Age=-1; Path=/; SameSite=Strict; Secure`;
  }
}
